import { z } from 'zod';

import { Temporal } from '@willow/types-iso';

import { Expression } from '../../Expressions/AbstractExpressionEvaluator';

/**
 * Expiration/Time-based Failure
 */

export const DueNever = z.object({
  type: z.literal('dueNever'),
});

export type DueNever = z.infer<typeof DueNever>;

export const DueAfterDuration = z.object({
  type: z.literal('dueAfterDuration'),
  duration: z
    .union([z.string(), z.instanceof(Temporal.Duration)])
    .transform((value) => Temporal.Duration.from(value))
    .meta({
      description: 'The duration after which the step is due in ISO 8601 Duration format.',
      example: 'P1D',
      type: 'string',
    }),
  timeOfDay: z
    .union([z.string(), z.instanceof(Temporal.PlainTime)])
    .transform((value) => Temporal.PlainTime.from(value))
    .optional()
    .meta({
      description: 'The time of day at which the step is due in ISO 8601 Time format.',
      example: '14:30:00',
      type: 'string',
    }),
});
export type DueAfterDuration = z.infer<typeof DueAfterDuration>;

export const DueOnDateExpression = z.object({
  type: z.literal('dueOnDateExpression'),
  expression: Expression('zonedDateTime').meta({
    description: 'An expression that evaluates to a ZonedDateTime on which the step is due.',
    example: 'zonedDateTime(plainDateFromForm(someFormDefinitionId, "$.pathToDate"))',
  }),
});
export type DueOnDateExpression = z.infer<typeof DueOnDateExpression>;

export const DueDefinition = z.discriminatedUnion('type', [DueNever, DueAfterDuration, DueOnDateExpression]);
export type DueDefinition = z.infer<typeof DueDefinition>;
